import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner-text',
  standalone: false,

  templateUrl: './spinner-text.component.html',
  styleUrl: './spinner-text.component.scss'
})
export class SpinnerTextComponent {
  @Input() text: string;
}
